/**
*
* AccountModal
*
*/

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import FormModal from 'components/interaction/FormModal/index.jsx';
import { useApi2post } from 'containers/Api2/index.js';
import { intlBreak } from 'utils/intlFunctions.jsx';
import { useWidth } from 'utils/checkMedia.js';
import schema from './form.js';
import messages from './messages.js';

function AccountModal(props) {
  const { account, onHide, show } = props;
  const wide = useWidth('sm');
  const api2post = useApi2post();
  const handleSubmit = useCallback((body) => {
    api2post({ url: 'sa/bankaccounts', version: 2, body });
  }, [api2post]);
  return (
    <FormModal
      show={show}
      onHide={onHide}
      title={messages.addAccount}
      values={account}
      schema={schema}
      onSubmit={handleSubmit}
      horizontal={wide}
    >
      <p className="form-text mb-4">
        <FormattedMessage {...messages.helpAccountForm} values={intlBreak} />
      </p>
    </FormModal>
  );
}

AccountModal.propTypes = {
  show: PropTypes.bool,
  account: PropTypes.object,
  onHide: PropTypes.func.isRequired,
};

export default AccountModal;
